module.exports = __webpack_public_path__ + "img/menu-cho-express.97de06e8.webp";